import forEach from 'lodash/forEach'

function onFocus(element) {
  const wrapper = element.closest('ul')

  if (wrapper) {
    const items = wrapper.querySelectorAll('.dropdown--active a')
    if (items) {
      forEach(items, (item) => {
        item.parentElement.classList.remove('dropdown--active')
        item.setAttribute('aria-expanded', false)
      })
    }
  }

  const parent = element.closest('.dropdown')

  if (parent) {
    element.setAttribute('aria-expanded', true)
    parent.classList.add('dropdown--active')
  }

  return element
}

document.addEventListener('DOMContentLoaded', () => {
  let rootElement = null
  const elements = document.querySelectorAll('.dropdown a')

  forEach(elements, (element) => {
    element.addEventListener('focus', () => {
      if (!rootElement) {
        rootElement = onFocus(element)
        // rootElement.parentElement.addEventListener('keydown', () => {
        //   window.console.log(event.target)
        // }, false)
      }
      onFocus(element)
    })

    element.addEventListener('focusout', () => {
      const { relatedTarget } = window.event // destino
      if (!relatedTarget) {
        const items = rootElement.parentElement.querySelectorAll('.dropdown--active a')
        if (items) {
          forEach(items, (item) => {
            item.parentElement.classList.remove('dropdown--active')
            item.setAttribute('aria-expanded', false)
          })
        }
        rootElement = null
        return
      }

      const x = relatedTarget.closest('.dropdown--active')

      if (!x) {
        const items = rootElement.parentElement.querySelectorAll('.dropdown--active a')
        if (items) {
          forEach(items, (item) => {
            item.parentElement.classList.remove('dropdown--active')
            item.setAttribute('aria-expanded', false)
          })
        }
        rootElement = null
      }
    })
  })
})
